import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { mostrarModulo } from "../../../redux/actions/actGlobal";

/**
 * Registra el modulo activo. `nombre` es el titulo del navbar, tal cual se
 * lee (legible, como "Gestión Procesos Académicos" en los demas modulos);
 * la `ruta` marca la opcion del sidebar (ver menuPrincipal en Rutas.js).
 */
export const useModulo = (ruta, nombre) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(mostrarModulo({ ruta, nombre }));
  }, [dispatch, ruta, nombre]);
};
